import { createFileRoute } from "@tanstack/react-router";
import { ClinicalPageShell } from "@/components/clinical";
import { CrudShellHeader } from "@/components/ds";
import { PriceListsPanel } from "@/components/catalog/PriceListsPanel";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";

export const Route = createFileRoute("/app/catalogacion/listas-precios")({
  component: CatalogacionListasPreciosPage,
  head: () => ({ meta: [{ title: "Listas de precios — Catalogación" }] }),
});

function CatalogacionListasPreciosPage() {
  const tid = useWorkspaceTenantId();

  return (
    <div>
      <CrudShellHeader title="Listas de precios" backHref="/app/catalogacion" backLabel="Volver a Catalogación" />
      <ClinicalPageShell offset="none" className="pt-6">
        {tid ? (
          <div className="mt-4">
            <PriceListsPanel tenantId={tid} />
          </div>
        ) : null}
      </ClinicalPageShell>
    </div>
  );
}
